import React, { Component } from "react";
import { PARTICIPANT_ID_PATTERN } from "../helpers/experiment";

const ENTRANCE_CODE = "IMI";

/**
 * Shown at "/" when the URL carries no participant IDs. In production a
 * Qualtrics link always carries them (/?qualtrics_id=...&prolific_id=...&group=N)
 * so this page is never seen by real participants; it exists purely so
 * testers can type the values by hand instead of editing the URL. The
 * entrance code is a shared gate (not per-user auth) just to keep random
 * visitors out.
 */
class InvalidEntry extends Component {

  constructor(props) {
    super(props);
    this.state = {
      qualtricsId: "",
      prolificId: "",
      group: "0",
      code: "",
      error: undefined,
    };
  }

  handleSubmit(e) {
    e.preventDefault();
    const { qualtricsId, prolificId, group, code } = this.state;
    if (code.trim().toUpperCase() !== ENTRANCE_CODE) {
      this.setState({ error: "Incorrect entrance code." });
      return;
    }
    if (!PARTICIPANT_ID_PATTERN.test(qualtricsId.trim()) || !PARTICIPANT_ID_PATTERN.test(prolificId.trim())) {
      this.setState({ error: "Qualtrics ID and Prolific ID are required (letters, digits, _ or -)." });
      return;
    }
    const params = new URLSearchParams({
      qualtrics_id: qualtricsId.trim(),
      prolific_id: prolificId.trim(),
      group,
    });
    this.props.history.push(`/?${params.toString()}`);
  }

  render() {
    const { qualtricsId, prolificId, group, code, error } = this.state;
    return (
      <div id="invalid-entry-page">
        <form className="invalid-entry-form" onSubmit={(e) => this.handleSubmit(e)}>
          <label htmlFor="entranceCode">Entrance code</label>
          <input
            type="text"
            id="entranceCode"
            className="form-control"
            placeholder="Entrance code"
            value={code}
            onChange={(e) => this.setState({ code: e.target.value })}
          />
          <label htmlFor="testQualtricsId">Qualtrics ID</label>
          <input
            type="text"
            id="testQualtricsId"
            className="form-control"
            placeholder="R_abc123"
            value={qualtricsId}
            onChange={(e) => this.setState({ qualtricsId: e.target.value })}
          />
          <label htmlFor="testProlificId">Prolific ID</label>
          <input
            type="text"
            id="testProlificId"
            className="form-control"
            placeholder="5f1e2d3c4b5a69788796a5b4"
            value={prolificId}
            onChange={(e) => this.setState({ prolificId: e.target.value })}
          />
          <label htmlFor="testGroup">Group</label>
          <select
            id="testGroup"
            className="form-control"
            value={group}
            onChange={(e) => this.setState({ group: e.target.value })}
          >
            <option value="0">0</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
          </select>
          <button type="submit" className="store-button">Enter</button>
          {error && <div className="alert alert-danger" role="alert">{error}</div>}
        </form>
      </div>
    );
  }
}

export default InvalidEntry;
